'use client';

import {styled} from "@mui/system";
import {Box, BoxProps} from "@mui/material";

const IssueItemText = styled(({...props }: BoxProps) => (
    <Box {...props} />
))(() => ({
    ' span ' : {
        fontSize: '1rem',
        fontWeight: '400',
    },
    '.arrow': {
        color: '#212529',
        marginRight: '.5rem',
        marginLeft: '.5rem',
    },
    '.icon': {
        color: '#C8AE68',
        fontSize: '1.25rem',
        ':hover': {
            opacity: '.8'
        }
    }
}));

export default IssueItemText;